module.exports = __webpack_public_path__ + "img/Mayscot Counter Strike CS6.jpg";